import { graphql } from "gatsby"

import { ProductPageTemplate } from "./ProductPageTemplate"

export const query = graphql`
  query getProduct($cataloguePath: String!) {
    crystallize {
      product: catalogue(path: $cataloguePath) {
        ...crystallize_item
        ...crystallize_product
      }
    }
  }
`
export default ProductPageTemplate
